export const DEFAULT_LOADING_MESSAGE = 'Loading';
